import { useGetTemplateOnboardingViewedTime } from './useTemplateOnboardingViewedTime.ts';

export const useShouldHideFeatureForCfind3673 = () => {
	const { templateOnboardingViewedTime, isLoading } = useGetTemplateOnboardingViewedTime();
	if (isLoading) {
		return { isLoading: true, shouldHideFeatureForCfind3673: undefined };
	}
	const msSinceOnboardingViewed = Date.now() - templateOnboardingViewedTime;
	const daysSinceOnboardingViewed = Math.floor(msSinceOnboardingViewed / (1000 * 60 * 60 * 24));
	const shouldHideFeatureForCfind3673 = daysSinceOnboardingViewed === 0;
	return {
		isLoading,
		shouldHideFeatureForCfind3673,
	};
};
